import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import reportIcon from "../../../assets/svg/reportBlue.svg";
import { gettingStartedProgress } from "../../../actions/globalAction";
import { Link } from "react-router-dom";
import reportsImg from "../../../assets/create-reports.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class CreateReports extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}
    handleCreateReports = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.setModule("Listening");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={reportIcon} className="icon_content" />
                            <span className="content_title">Create Reports</span>
                        </div>
                        <div className="text_content">
                            <p>{`For those days when you do not wish to login to the platform but still have information delivered to your inbox :-) `}</p>
                            <p>{`Just create reports in this section. You can create insightful and customized reports based on a wide variety of options.  Create Reports, Schedule Reports and have them delivered to your inbox on a daily, weekly or monthly basis.  You also want the reports sent to a colleague?  No problem, we have that covered too!`}</p>
                        </div>
                        <Link to="/reports">
                            <button className="gs_link" onClick={this.handleCreateReports}>
                                Create Reports
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/iti2h2BXb94?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={reportsImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveModule: (data) => dispatch(setActiveModule(data)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateReports);
